// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"59":"bc82f51769857e6e","134":"b76f39db4c77b7f2"}[chunkId] + ".js";
};